export enum SettingsItem{
    ExtensionUrl = 0
}

export const getSetting = async (item: SettingsItem): Promise<string> => {
    try{
        const response = await fetch("/settings.json");
        const settings = await response.json();
        switch (item) {
            case SettingsItem.ExtensionUrl:
                return settings.extensionLink;
            default:
                    return "";
        }
    }
    catch (e) {
        console.error(e);
    }
    return "";
}